import { getFileExtension } from 'ComponentLibrary/src/common/files'

const mimeTypeToFileExtensionMap = {
    'application/pdf': 'pdf',
    'application/xml': 'xml',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
    'text/plain': 'txt',
    'text/markdown': 'md',
    'text/x-markdown': 'md',
    'image/jpg': 'jpg',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
} as const

const recognizedFileExtensions = [
    'csv',
    'doc',
    'docx',
    'gif',
    'jpeg',
    'jpg',
    'ods',
    'odt',
    'pdf',
    'png',
    'ppt',
    'pptx',
    'rtf',
    'svg',
    'tif',
    'tiff',
    'txt',
    'webp',
    'xls',
    'xlsm',
    'xlsx',
    'xml',
    'zip',
]

export const getFileExtensionForContentType = (contentTypeHeader?: string) => {
    const normalizedContentType = contentTypeHeader?.split(';')[0]?.trim().toLowerCase()

    if (!normalizedContentType) {
        return undefined
    }

    return mimeTypeToFileExtensionMap[normalizedContentType as keyof typeof mimeTypeToFileExtensionMap]
}

export const getNormalizedFileName = (file?: { name: string; content_type?: string }) => {
    if (!file) {
        return ''
    }

    const existingExtension = getFileExtension(file.name)
    if (existingExtension && recognizedFileExtensions.includes(existingExtension)) {
        return file.name
    }

    const extension = getFileExtensionForContentType(file.content_type)
    return extension ? `${file.name}.${extension}` : file.name
}
